import { AnyComparator, ClientDataType, FieldType } from 'modules/queryBuilder/types';

/**
 *
 * Some comparators have the same value but different labels.
 * This is an internal enum used to differentiate comparators
 *
 */
export enum ComparatorSelectType {
  boolean = 'boolean',
  string = 'string',
  number = 'number',
  date = 'date',
  geoLocation = 'geoLocation',
  list = 'list',
  object = 'object',
  brandAffinity = 'brandAffinity',
  isOneOf = 'isOneOf',
  campaignLabel = 'campaignLabel',
  campaign = 'campaign',
  template = 'template',
  messageType = 'messageType',
  regex = 'regex',
  default = 'default',
}

export type ComparatorSelectProps = {
  dataType: ClientDataType;
  field: string;
  fieldType: FieldType;
  value: AnyComparator | null;
  onChange: (value: AnyComparator) => void;
  isInvalid?: boolean;
  hasWarning?: boolean;
  isOpenByDefault?: boolean;
};
